<script lang="ts">
	import type { Snippet } from 'svelte'

	// `fold`: the title row opens and closes the section. Unless the page binds `open`, it starts closed on narrow
	// screens, where long sections (Admin, Workflows) would otherwise make one very tall page, and open on wide ones.
	let {
		title,
		sub,
		actions,
		fold = false,
		open = $bindable(typeof window === 'undefined' || window.innerWidth >= 768),
		children,
	}: {
		title?: string
		sub?: string | null
		actions?: Snippet
		fold?: boolean
		open?: boolean
		children: Snippet
	} = $props()

	const shown = $derived(!fold || open)
</script>

<section class="sheet">
	{#if title || actions}
		<div class="sheet-head">
			{#if fold}
				<button
					class="flex min-h-11 min-w-0 flex-1 cursor-pointer items-start gap-2 border-0 bg-transparent p-0 text-left"
					type="button"
					aria-expanded={open}
					onclick={() => (open = !open)}
				>
					<span class="text-muted mt-1 w-4 shrink-0 text-sm" aria-hidden="true">{open ? '▾' : '▸'}</span>
					<span class="min-w-0">
						{#if title}<h2>{title}</h2>{/if}
						{#if sub}<span class="sub">{sub}</span>{/if}
					</span>
				</button>
			{:else}
				<div>
					{#if title}<h2>{title}</h2>{/if}
					{#if sub}<span class="sub">{sub}</span>{/if}
				</div>
			{/if}
			{#if actions && shown}<div class="flex flex-wrap gap-2">{@render actions()}</div>{/if}
		</div>
	{/if}
	{#if shown}{@render children()}{/if}
</section>
